module.exports = __webpack_public_path__ + "img/bg_pno_lineup.b94d4dda.jpg";